import { coordenadaTypes } from "../../types/coordenadaTypes"

export const setCoordenadas = ( payload ) => ({
    type: coordenadaTypes.SET_COORDENADA,
    payload
})
